import { useState } from 'react'
import { Copy } from 'lucide-react'
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@axilon-apps/libs-ui-shadcn'

interface Props {
  textToCopy: string
  onCopySuccess?: (isCopied: boolean) => void
}

const CopyToClipboard = ({ textToCopy, onCopySuccess }: Props) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy)
      setCopied(true)
      onCopySuccess?.(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy: ', err)
    }
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            size="icon-sm"
            onClick={handleCopy}
            className={copied ? 'text-st-run' : 'text-muted-foreground'}
          >
            <Copy />
          </Button>
        </TooltipTrigger>
        <TooltipContent>{copied ? 'Copied!' : 'Copy to clipboard'}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default CopyToClipboard
